const initialState = {
    currentUser:null,
    pageTitle:"Title"
};

const layoutDataReducer =(state = initialState, action)=>{
    if (action.type === "title"){
        return { ...state, pageTitle: action.value};
    }

    return state;
};

export default layoutDataReducer;